<template>
  <div>
    <InputValidate
      v-validate="'required'"
      :value="addressStr"
      :title="$t('region')"
      name="region"
      data-vv-value-path="innerValue"
      :error="errors.first('region')"
      :readonly="true"
      :show-arrow="true"
      @click.native="isPickerShow = true"
    />
    <md-tab-picker
      v-model="isPickerShow"
      class="district-picker"
      large-radius
      :data="pickerData"
      @change="handleChange"
    />
  </div>
</template>

<script>
// 地址选择组件
import InputValidate from '@/components/InputValidate'
import { TabPicker } from 'mand-mobile'
import dataEn from '@/assets/region/district_en.json'

export default {
  name: 'InputAddressPicker',
  components: {
    InputValidate,
    [TabPicker.name]: TabPicker
  },
  data () {
    return {
      address: [],
      isPickerShow: false,
      pickerData: dataEn
    }
  },
  computed: {
    addressStr () {
      return this.address.map(item => item.label).join(' ')
    }
  },
  methods: {
    // 选择地区
    handleChange ({ options }) {
      this.address = options
      this.$emit('update:address', options[options.length - 1].value)
    },
    // 校验
    validate () {
      this.$validator.validate().then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.district-picker ::v-deep.md-radio-list {
  margin-bottom: 80px;
}
</style>
